import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {QbItemDto} from "../model/QbItemDto";
import {DisposeBag} from "../modules/DisposeBag";

class QbItemSearchController implements IComponentController {
    records: QbItemDto[] = [];
    model: QbItemDto;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllQbItem(() => this.records, this.disposeBag);
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }

    search = (query) => {
        this.records = [];
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.qbItemSubscribeSearch(query);
    }
}

export default angular.module('component.qbItemSearch', [])
    .component('qbItemSearch', {
        template: require('./QbItemSearch.html'),
        controller: QbItemSearchController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '=',
            itemType: '@'
        }
    }).name;
